import React from "react";
import { Card, CardTitle, CardText } from "material-ui/Card";
import RaisedButton from "material-ui/RaisedButton";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router";
import HomeHeaderBar from "./HomeHeaderBar";
import { getResults, getResponse, answerTextLookup } from "../reducer/response";
import CaveatVisualization from "../components/CaveatVisualization";
import { questionLookup } from "../reducer/questions";
import { CUSTOMIZED_ORDER, DEFAULT_ORDER, toggleHiddenOptions } from "../actions/filterOptions";
import { makeTitle } from '../reducer';
import { sortedCategories } from "../reducer/categories";
import { Subheader } from "material-ui";

class HarvestStrategyContatiner extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

    componentDidMount = () => {
      if (!this.props.loggedIn && this.props.authError) {
        this.props.router.push("/");
      }
    };


  render(){
    let {response, results} = this.props
    let monitoringResults = results["monitoring"]
    let assessmentResults = results["assessment"]
    let controlRulesResults = results["controlRules"]

    let monitoringStarred = (response &&
                                  response.userEdits &&
                                  response.userEdits["monitoring"] &&
                                  response.userEdits["monitoring"].starred) || []
    let assessmentStarred = (response &&
                                    response.userEdits &&
                                    response.userEdits["assessment"] &&
                                    response.userEdits["assessment"].starred) || [] 
    let controlRulesStarred = (response &&
                                      response.userEdits &&
                                      response.userEdits["controlRules"] &&
                                      response.userEdits["controlRules"].starred) || [] 

    let filterOptions = {
      displayHiddenOptions: false,
      order: CUSTOMIZED_ORDER,
      hideTags: false
    }

    let enabledActions = {
      hide: false,
      star: false
    }

    // let stageSettings = {
    //   showFiltersAndSorting: false,
    //   filterOptions: {
    //     displayHiddenOptions: false,
    //     order: CUSTOMIZED_ORDER,
    //     hideTags: false
    //   },
    //   actions: {
    //     hide: false,
    //     star: false
    //   },
    //   shortList: true
    // }

    return(
      <div>
        {/* { !response ? <HomeHeaderBar /> : null } */}
        <Card style={{ maxWidth: 1280, margin: !!response ? "auto" : "80px auto" }}>
          <CardTitle titleStyle={{fontSize:32, textAlign:'center'}} title={!response ? "Harvest Strategy Support Page - Reference" : "Harvest Strategy Support Page"} />
          <CardText>
            Harvest strategies are an approach to fisheries management under which managers and stakeholders identify objectives and agree in advance to formal adjustments of management responses based on the status of the fish population or other assessment outputs. Harvest strategies are designed to achieve the identified objectives and ensure the health of the species and the fishery . In a harvest strategy, a monitoring program is designed to collect information needed to track the health of the stock and compliance with regulations. The data collected are then used within a stock assessment for a direct or indirect measure of stock status.  The assessment result is then used within a pre-agreed harvest control rule to adjust management measures, implemented as a management response. For static management measures, the assessment result does not inform regular adjustments to the measure, but is used to track fishery health over time that is used within a pre-agreed framework to adjust or add additional measures when needed.
            <br/><br/>
            {!response && "To populate with the specific top options for a given fishery, access this page from the results for that fishery." }
            <figure style={{maxWidth: 750, margin: "20px auto"}}>
              <img src="/hs_diagram.png?v=2" alt="" style={{objectFit: 'fill', maxWidth: 750}}/>
              <figcaption>Simplified concept of linking the 3 sections within the FishPath Tool.</figcaption>
            </figure>
          </CardText>

          {
            !!response && 
            <div>
              <CardTitle title="FishPath Tool Top Options for Harvest Strategy Components" />
              <CardTitle title="Data Collection" titleStyle={{fontSize:20}}/>
              <CaveatVisualization
                displayCriteria={true}//section !== "controlRules"}
                colorCodedCriteria={false}//section === "assessment"}
                onNoteClick={() => {}}
                onOptionClick={() => {}}
                // onQuestionClick={this.onQuestionClick}
                section={"monitoring"}
                answerTextLookup={this.props.answerTextLookup}
                questionLookup={this.props.questionLookup}
                {...monitoringResults}
                options={monitoringResults.options.filter(o => monitoringStarred.indexOf(o.id) !== -1)}
                readOnly={this.props.readOnly}
                responseID={this.props.responseID}
                onToggleOptionHidden={() => {}}
                userEdits={response.userEdits}
                fishery={makeTitle(response)}
                filterOptions={filterOptions}
                categories={this.props.categories}
                hideAllOptionsLink={true}
                response={response}
                enabledActions={enabledActions}
                inHarvestStrategy={true}
              />

              <CardTitle title="Assessment" titleStyle={{fontSize:20}} />
              <CaveatVisualization
                displayCriteria={true}//section !== "controlRules"}
                colorCodedCriteria={true}//section === "assessment"}
                onNoteClick={() => {}}
                onOptionClick={() => {}}
                // onQuestionClick={this.onQuestionClick}
                section={"assessment"}
                answerTextLookup={this.props.answerTextLookup}
                questionLookup={this.props.questionLookup}
                {...assessmentResults}
                options={assessmentResults.options.filter(o => assessmentStarred.indexOf(o.id) !== -1)}
                readOnly={this.props.readOnly}
                responseID={this.props.responseID}
                onToggleOptionHidden={() => {}}
                userEdits={response.userEdits}
                fishery={makeTitle(response)}
                filterOptions={filterOptions}
                categories={this.props.categories}
                hideAllOptionsLink={true}
                response={response}
                enabledActions={enabledActions}
                inHarvestStrategy={true}
              />
              <CardTitle title="Management Measures" titleStyle={{fontSize:20}} />
              <CaveatVisualization
                displayCriteria={false}//section !== "controlRules"}
                colorCodedCriteria={false}//section === "assessment"}
                onNoteClick={() => {}}
                onOptionClick={() => {}}
                // onQuestionClick={this.onQuestionClick}
                section={"controlRules"}
                answerTextLookup={this.props.answerTextLookup}
                questionLookup={this.props.questionLookup}
                {...controlRulesResults}
                options={controlRulesResults.options.filter(o => controlRulesStarred.indexOf(o.id) !== -1)}
                readOnly={this.props.readOnly}
                responseID={this.props.responseID}
                onToggleOptionHidden={() => {}}
                userEdits={response.userEdits}
                fishery={makeTitle(response)}
                filterOptions={filterOptions}
                categories={this.props.categories}
                hideAllOptionsLink={true}
                response={response}
                enabledActions={enabledActions}
                inHarvestStrategy={true}
              />
            </div>
            
          }

          <hr />
          <CardTitle title="Harvest Strategy Resources" />
          
          <CardText>
            <Subheader>
              Resources and Examples:
            </Subheader>
            <ul>
              <li><a href="https://harveststrategies.org/" rel="noopener noreferrer" target="_blank">https://harveststrategies.org/</a></li>
              <li><a href="https://www.daf.qld.gov.au/business-priorities/fisheries/sustainable/harvest-strategy" rel="noopener noreferrer" target="_blank">https://www.daf.qld.gov.au/business-priorities/fisheries/sustainable/harvest-strategy</a></li>
              <li><a href="https://www.dpi.nsw.gov.au/fishing/harvest-strategies" rel="noopener noreferrer" target="_blank">https://www.dpi.nsw.gov.au/fishing/harvest-strategies</a></li>
            </ul>
            <Subheader>
              References:
            </Subheader>
            <ul>
              <li>Fowler, A.M., Ochwada-Doyle, F.A., Dowling, N.A., Folpp, H., Hughes, J.M., Lowry, M.B., Lyle, J.M., Lynch, T.P., Miles, N.G., Chick, R.C., 2022. Integrating recreational fishing into harvest strategies: linking data with objectives. <i>ICES Journal of Marine Science 79</i>(2). <a href="https://doi.org/10.1093/icesjms/fsab270" rel="noopener noreferrer" target="_blank">https://doi.org/10.1093/icesjms/fsab270</a></li>
              <li>Hill, N.J., Peatman, T., Wakefield, C.B., Newman, S.J., Halafihi, T., Kinch, J., Edwards, C.T.T., Nicol, S.J., Williams, A.J., 2018. Improving guidelines for implementing harvest strategies in capacity-limited fisheries – Lessons from Tonga’s deepwater line fishery. <i>Marine Policy 98</i>, 85–91. <a href="https://doi.org/10.1016/j.marpol.2018.09.015" rel="noopener noreferrer" target="_blank">https://doi.org/10.1016/j.marpol.2018.09.015</a></li>
              <li>Smith, A.D.M., Smith, D.C., Haddon, M., Knuckey, I.A., Sainsbury, K.J., Sloan, S.R., 2014. Implementing harvest strategies in Australia: 5 years on. <i>ICES J. Mar. Sci. 71</i>, 195–203. <a href="https://doi.org/10.1093/icesjms/fst158" rel="noopener noreferrer" target="_blank">https://doi.org/10.1093/icesjms/fst158</a></li>
              <li>Smith, A.D.M., Smith, D.C., Tuck, G.N., Klaer, N., Punt, A.E., Knuckey, I., Prince, J., Morison, A., Kloser, R., Haddon, M., Wayte, S., Day, J., Fay, G., Pribac, F., Fuller, M., Taylor, B., Little, L.R., 2008. Experience in implementing harvest strategies in Australia’s south-eastern fisheries. <i>Fisheries Research 94</i>, 373–379. <a href="https://doi.org/10.1016/j.fishres.2008.06.006" rel="noopener noreferrer" target="_blank">https://doi.org/10.1016/j.fishres.2008.06.006</a></li>
            </ul>
          </CardText>
        </Card>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  let fetching = false;
  fetching = state.responses.fetching;
  let response = getResponse(state);
  const results = getResults(state);
  let readOnly = response
    ? response.email != state.auth.email && !state.auth.isAdmin
    : true;

  return {
    loggedIn: !!state.auth.token,
    authError: state.auth.error,
    responseID: ownProps.routeParams.id,
    response,
    results,
    answerTextLookup: answerTextLookup(state),
    questionLookup: questionLookup(state),
    categories: (sortedCategories(state.categories) || []).filter(
      c => c.type === "target" || c.type === "option"
    ),
    readOnly
    // email: state.auth.email,
    // isAdmin: state.auth.isAdmin,
    // translationList: state.translationList.filter(tr => tr.published),
    // translations: state.translations
  };
};

const mapDispatchToProps = dispatch => {
  return {

  };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(withRouter(HarvestStrategyContatiner));
